<template>
  <DropdownComponent v-if="tasks.length" :close-on-click="false" class="task-button-list">
    <template #default>
      <div class="task-button-list__trigger">
        <ButtonComponent :icon="{ icon: ['fal', 'tasks'], size: 'lg' }" :label="$tc('task', 2)" />
        <div class="task-button-list__badge">{{ tasks.length }}</div>
      </div>
    </template>
    <template #dropdown="{ close }">
      <ButtonComponent
        v-for="task in tasks"
        :key="task.id"
        @click="onClick(task, close)"
        class="task-button-list__item"
      >
        <b>{{ task.title }}</b>
        <span>
          <template v-if="task.dueAt">{{ $t('deadline') }}: {{ task.dueAt | Moment('DD. MMM YYYY') }}</template>
          <template v-else>{{ $t('noDeadline') }}</template>
          <FontAwesomeIcon :icon="['fal', 'calendar-exclamation']" />
        </span>
      </ButtonComponent>
    </template>
  </DropdownComponent>
</template>

<script>
import { Moment } from '@/filters'
import { PartialUpdate } from '@/utils'

import { DropdownComponent } from 'vue-elder-dropdown'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    referenceId: {
      type: String,
      required: true,
    },
  },
  computed: {
    tasks() {
      return this.value.filter(v => v.status !== 'done')
    },
  },
  methods: {
    onClick(item, close) {
      close()
      this.$bus.$emit('task', { id: item.id }, e => this.$emit('update', e))
    },
    onTaskUpdate(task) {
      if (task.reference.ref !== this.referenceId) return

      let match = this.value.find(t => t.id === task.id)
      if (!match) return this.value.push(task)
      PartialUpdate(match, task, { strict: true })
    },
    onTaskRemove(id) {
      let index = this.value.findIndex(t => t.id === id)

      if (!~index) return
      this.value.splice(index, 1)
    },
  },
  created() {
    this.$bus.$on('task:create', this.onTaskUpdate)
    this.$bus.$on('task:update', this.onTaskUpdate)
    this.$bus.$on('task:remove', this.onTaskRemove)
  },
  beforeDestroy() {
    this.$bus.$off('task:create', this.onTaskUpdate)
    this.$bus.$off('task:update', this.onTaskUpdate)
    this.$bus.$off('task:remove', this.onTaskRemove)
  },
  filters: {
    Moment,
  },
  components: {
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.task-button-list {
  &__trigger {
    position: relative;
  }

  &__badge {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;

    padding: 2px 7px;
    border-radius: 10px;
    color: white;
    background-color: var(--error);

    font-family: monospace;
    font-size: 0.8em;

    transform: translate(20%, -30%);
  }

  &__item {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 5px;

    padding: 0.75rem;

    svg {
      margin-left: 5px;
      opacity: 0.4;
    }

    & + & {
      border-top: 1px solid css-lighten('border-color', 6%);
    }
  }
}
</style>
